import { IMappedContext } from './common'
import { IFunction, IPermissions, KeyValue } from '../types'

export const injectA8Config = (config: KeyValue, permissions: IPermissions) => {
  let code = `
    class A8Config {
      data = {}
      constructor(data) {
        this.data = data
      }
      getConfig(key) {
        return this.data[key]
      }
    }
    let a8config = {};
  `

  if (permissions.a8config.includes('getConfig')) {
    code += `a8config = new A8Config(${JSON.stringify(config)})`
  } else {
    code += `a8config.getConfig = () => { throw new Error("permission denied: getConfig") }`
  }

  return code
}

export const injectNamespace = (
  namespace: string,
  functions: IFunction[],
  permissions: string[]
) => {
  const fns = getFunctions(namespace, functions)

  let code = `const ${namespace} = {};`
  fns.forEach((fn) => {
    const name = fn.name
    const value = fn.type === 'string' ? JSON.stringify(fn.resp) : fn.resp
    code += '\n'

    if (permissions.includes(name)) {
      code += `${namespace}.${name} = () => { return ${value} }`
    } else {
      code += `${namespace}.${name} = () => { throw new Error("permission denied: '${fn.name}'") }`
    }
  })

  return code
}

const invokeMainFn = (params: KeyValue, client: boolean) => {
  const prepend = client ? 'return ' : ''
  return (
    prepend +
    `main(${JSON.stringify(
      params
    )}).then(res => res).catch(err => { throw err })`
  )
}

export const getFunctions = (sdk: string, functions: IFunction[]) => {
  return functions.filter((fn) => fn.sdk === sdk)
}

export const bootstrapCode = (
  context: IMappedContext,
  code: string,
  client: boolean,
  permissions: IPermissions
) => {
  return [
    injectA8Config(context.a8config, permissions),
    injectNamespace('a8flow', context.functions, permissions.a8flow || []),
    injectNamespace('a8Astro', context.functions, permissions.a8Astro || []),
    injectNamespace('a8func', context.functions, permissions.a8func || []),
    code,
    invokeMainFn(context.params, client),
  ].join('\n')
}
